import { IconDefinition } from "./types";

const tag: IconDefinition = {
  iconName: "tag",
  width: 576,
  height: 512,
  svgPathData:
    "M72.4 16l-24 0 0 257.9 7 7 224 224 17 17 17-17 224-224 17-17-17-17-224-224-7-7-233.9 0zm24 238.1l0-190.1 190.1 0 200 200-190.1 190.1-200-200zm80-78.1a32 32 0 1 0 0-64 32 32 0 1 0 0 64z",
  iconType: "fill",
  fill: "none",
  fontAwesomeName: "tag",
  unicode: 0xf02b,
};

export { tag };
